import { Action, createReducer, on } from '@ngrx/store';
// import {DiagnosticStore} from '../../models/store/user/patient';

// TODO: Add Interfaces

import { editDiagnostic, loadDiagnostics, paginateDiagnostics, removeAllDiagnostics, removeDiagnostics } from 'src/actions/user/diagnostics.action';

export const initialState: any = {
  fetching: false,
  data: {
    diagnostics: [],
    totalDocuments: 0
  }
};

const diagnosticsReducer = createReducer(initialState,
  on(loadDiagnostics, (state, { payload, totalDocuments }) => (
    {
      ...state,
      data: {
        ...state.data,
        diagnostics: [
          ...state.data.diagnostics,
          ...payload.filter(p => !state.data.diagnostics.find((ds: any) => ds._id === p._id))
        ],
        totalDocuments
      }
    })
  ),
  on(editDiagnostic, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        diagnostics: state.data.diagnostics.map(
          (data: any) => {
            if (data._id === payload._id) {
              return {
                ...data,
                ...payload
              };
            }

            return data;
          }
        )
      }
    })
  ),
  on(removeDiagnostics, (state, { payload }) => (
    {
      ...state,
      data: {
        ...state.data,
        diagnostics: state.data.diagnostics
          .filter((d: any) => !payload.includes(String(d._master))),
        totalDocuments: state.data.totalDocuments - 1,
      }
    })
  ),
  on(removeAllDiagnostics, (state) => (
    {
      ...state,
      data: {
        ...state.data,
        diagnostics: [],
        totalDocuments: 0
      }
    }
  )
  ),
  on(paginateDiagnostics, (state) => state)
);

export function reducer(state: any, action: Action): any {
  return diagnosticsReducer(state, action);
}
